import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { Reveal, SectionHeading, EstimateBanner } from '../components/shared';
import { categories } from '../mock/mock';

function PageHeader({ eyebrow, title, sub, image }) {
  return (
    <section className="relative bg-brand-charcoal">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal via-brand-charcoal/70 to-brand-charcoal/40" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-6 pt-20 pb-16 md:pt-28 md:pb-20">
        <span className="text-brand-clay text-xs font-semibold uppercase tracking-[0.3em]">{eyebrow}</span>
        <h1 className="font-display text-4xl md:text-6xl font-semibold text-brand-ivory mt-4 leading-[1.05] text-balance max-w-3xl">{title}</h1>
        {sub && <p className="mt-5 text-brand-sand/80 text-lg max-w-2xl leading-relaxed">{sub}</p>}
      </div>
    </section>
  );
}

export { PageHeader };

export default function Flooring() {
  return (
    <>
      <PageHeader
        eyebrow="Our Flooring"
        title="Premium floors for every room"
        sub="Browse our full range of name-brand flooring. Fall in love with a look, then let us bring the samples to your home."
        image="https://images.unsplash.com/photo-1649083048337-4aeb6dda80bb?auto=format&fit=crop&w=1920&q=80"
      />
      <section className="max-w-7xl mx-auto px-6 py-20 md:py-24">
        <div className="grid gap-8 md:grid-cols-2">
          {categories.map((c, idx) => (
            <Reveal key={c.slug} delay={(idx % 2) * 100}>
              <Link to={`/flooring/${c.slug}`} className="cat-card group grid sm:grid-cols-2 rounded-2xl overflow-hidden bg-white border border-brand-line shadow-sm hover:shadow-xl transition-shadow">
                <div className="overflow-hidden h-56 sm:h-full">
                  <img src={c.image} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div className="p-7 flex flex-col justify-center">
                  <h3 className="font-display text-2xl font-semibold text-brand-charcoal">{c.name}</h3>
                  <p className="mt-3 text-brand-stone text-[15px] leading-relaxed">{c.short}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-brand-clay text-sm font-semibold">
                    Explore {c.name.split(' ')[0]} <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <EstimateBanner />
    </>
  );
}
